import { CurrencyType } from 'constants/Currencies';

export const getCurrencySymbol = (currency: CurrencyType | null) => {
  return currency?.symbol || ''
};